export type NodeTypeConfig = {
  id: string;
  label: string;
  defaultColor: string;
  defaultTextColor?: string;
  icon?: string;
  category?: string;
};

export const NODE_TYPES: NodeTypeConfig[] = [
  { id: "root", label: "Root", defaultColor: "#1e3a8a", defaultTextColor: "#ffffff", category: "core" },
  { id: "hauptgremium", label: "Hauptgremium", defaultColor: "#0f766e", defaultTextColor: "#ffffff", category: "core" },
  { id: "gruppe", label: "Gruppe", defaultColor: "#2563eb", defaultTextColor: "#ffffff", category: "group" },
  { id: "ortsgruppe", label: "Ortsgruppe", defaultColor: "#7c3aed", defaultTextColor: "#ffffff", category: "group" },
  { id: "arbeitskreis", label: "Arbeitskreis", defaultColor: "#ea580c", defaultTextColor: "#ffffff", category: "work" },
  { id: "projektgruppe", label: "Projektgruppe", defaultColor: "#16a34a", defaultTextColor: "#ffffff", category: "work" },
  { id: "fraktion", label: "Fraktion", defaultColor: "#be123c", defaultTextColor: "#ffffff", category: "politics" },
  { id: "linksjugend", label: "Linksjugend", defaultColor: "#be4bdb", defaultTextColor: "#ffffff", category: "politics" },
];

export const nodeTypeById = (id?: string) => NODE_TYPES.find((t) => t.id === id);

